import gql from 'graphql-tag'

export interface QueryVariables {
  id: string
}

interface PersonnelHistory {
  officeId: string
}

interface Office {
  id: string
}

export interface Employee {
  id: string
  staffCode: string
  currentOffice: Office
  personnelHistory: PersonnelHistory
  displayFullName: string
}

export type QueryResult = {
  client: {
    id: number
    employee: Employee
  }
}

export const EMPLOYEE = gql`
  query employee($id: ID!) {
    client {
      id
      employee(employeeId: $id) {
        id
        staffCode
        currentOffice {
          id
        }
        personnelHistory {
          officeId
        }
        displayFullName
      }
    }
  }
`

export type FormErrorKey = 'procedureStatusId' | 'beforeOfficeId' | 'afterOfficeId' | 'relocateOn'

export const CREATE_PROCEDURE_CHANGE_OFFICE_DATUM = gql`
  mutation createProcedureChangeOfficeDatum($input: CreateProcedureChangeOfficeDatumInput!) {
    createProcedureChangeOfficeDatum(input: $input) {
      procedureStatus {
        id
        procedureChangeOfficeDatum {
          id
          procedureStatusId
          beforeOfficeId
          afterOfficeId
          relocateOn
        }
      }
    }
  }
`
